import { ChevronDownIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import classNames from "../../../../utils/classNames";
import PriceFormat from "../../../../utils/priceFormat";

export default function PartsPriceTile({
  value,
  partsTotal,
  partsCount,
  expanded,
  onToggle,
}: {
  value: number;
  partsTotal: number;
  partsCount: number;
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 p-3">
      <div className="mb-1 flex items-center gap-1.5">
        <span className="shrink-0 text-green-500">
          <WrenchScrewdriverIcon className="h-3.5 w-3.5" />
        </span>
        <span className="flex-1 text-[10px] font-semibold uppercase tracking-wider leading-tight text-gray-500">
          Parts Price
        </span>
        <button
          type="button"
          onClick={onToggle}
          className="shrink-0 rounded p-0.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-primary-600"
          title="View parts breakdown"
        >
          <ChevronDownIcon
            className={classNames("h-3.5 w-3.5 transition-transform", expanded && "rotate-180")}
          />
        </button>
      </div>

      <p className="text-sm font-bold text-gray-900">
        {value > 0 ? PriceFormat(value) : "—"}
        {partsTotal > 0 && (
          <span className="ml-1.5 text-[10px] font-medium text-green-600">({partsCount} parts)</span>
        )}
      </p>
    </div>
  );
}
